import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api, ApiError } from '../../api/client.ts';
import { useToast } from '../../components/ui/index.tsx';
import { t } from '../../i18n/index.ts';

/** Cierra la sesión en el servidor. Si el servidor no la cierra, la persona lo sabe y sigue donde estaba. */
export function useLogout() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  return async () => {
    try {
      await api.post('/api/auth/logout');
    } catch (e) {
      // 401: la sesión ya no existía, así que la persona ya está fuera.
      if (!(e instanceof ApiError && e.status === 401)) {
        toast({ tone: 'error', text: t('No se pudo cerrar la sesión. {error}', { error: e instanceof Error ? t(e.message) : '' }).trim() });
        return;
      }
    }
    qc.clear();
    navigate('/entrar', { replace: true });
  };
}
